module.exports = __webpack_public_path__ + "static/media/om_beard_tailored_round__oval.60a6f5be.png";